import { ItemList } from '../../orm'

class AdminSavedSearchesCustomerList extends ItemList {
    getEntityKey() {
        return "admin/saved_searches_customer"
    }
}

export const adminSavedSearchesCustomerList = new AdminSavedSearchesCustomerList("admin_saved_searches_customer__default")
